import React from 'react';
import { AutoComplete, Input } from 'antd';
import { Search } from 'lucide-react';
import { FilterBar, FilterField } from '../../common';
import { useCampaignSearch } from './campaignElements.controller';

const CampaignActions = ({ setRows, campaigns }) => {
    const { suggestions, searchValue, setSearchValue, handleSearch } = useCampaignSearch({ setRows, campaigns });

    return (
        <FilterBar label="Filtros" className="!mb-0">
            <FilterField label="Buscar" className="w-full sm:w-80">
                <AutoComplete
                    value={searchValue}
                    options={suggestions.map((value) => ({ value }))}
                    onSearch={handleSearch}
                    onSelect={handleSearch}
                    onChange={(value) => setSearchValue(value)}
                    placeholder="Buscar campaña...">
                    <Input prefix={<Search className="text-surface-400" />} allowClear />
                </AutoComplete>
            </FilterField>
        </FilterBar>
    );
};

export default CampaignActions;
